import client from '../httpClient';

const sendmailGetMailDetailApi = (params) => {
  return client.get('send-mails/details', { params });
};

export default sendmailGetMailDetailApi;
